/**
 * Returns true if a phrase contains one of the words provided.
 * @param {string[]} words - Array of strings to check for in...
 * @param {string} phrase - String to check
 */
export const includesOneOf = (words, phrase) => {
    return words.some((word) => phrase.includes(word))
}
